"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactCircularProgressbar = require("react-circular-progressbar");

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'CircularProgress');

var getColors = function getColors(type, colors) {
  return {
    info: {
      pathColor: colors.secondary
    },
    success: {
      pathColor: colors.green
    },
    warning: {
      pathColor: colors.yellow
    },
    danger: {
      pathColor: colors.red
    }
  }[type];
};

var getSizes = function getSizes(size, colors) {
  return {
    small: {
      textSize: 30,
      textColor: colors.greySoft
    },
    medium: {
      textSize: 25,
      textColor: colors.black
    },
    large: {
      textSize: 25,
      textColor: colors.black
    }
  }[size];
};

function CircularProgress(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      classNameProp = _ref.className,
      overridesProp = _ref.overrides,
      color = _ref.color,
      value = _ref.value,
      text = _ref.text,
      styles = _ref.styles,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 100 : _ref$maxValue,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "overrides", "color", "value", "text", "styles", "type", "size", "minValue", "maxValue"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  var theme = (0, _styles.useTheme)();
  var rootClassName = (0, _classnames2.default)(classes.root, (0, _defineProperty2.default)({}, classes[size], size), classNameProp);
  var override = (0, _overrides.getOverrides)(overridesProp, CircularProgress.overrides);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName
  });
  var circularProps = (0, _react.useMemo)(function () {
    return (0, _extends2.default)({
      value: value,
      minValue: minValue,
      maxValue: maxValue,
      text: text,
      styles: (0, _reactCircularProgressbar.buildStyles)((0, _extends2.default)({}, getColors(type, theme.colors), getSizes(size, theme.colors), {
        trailColor: theme.colors.greyLight,
        strokeLinecap: 'round',
        backgroundColor: 'none'
      }, styles)),
      strokeWidth: 5
    }, override.ReactCircularProgressBar);
  }, [maxValue, minValue, override.ReactCircularProgressBar, size, styles, text, theme.colors, type, value]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), children && /*#__PURE__*/_react.default.createElement(_reactCircularProgressbar.CircularProgressbarWithChildren, circularProps, children), !children && /*#__PURE__*/_react.default.createElement(_reactCircularProgressbar.CircularProgressbar, circularProps));
}

CircularProgress.overrides = ['root', 'CircularProgressBar'];
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  className: _propTypes.default.string,
  styles: _propTypes.default.object,
  children: _propTypes.default.node,
  value: _propTypes.default.number,
  text: _propTypes.default.string,
  maxValue: _propTypes.default.number,
  color: _propTypes.default.string,
  type: _propTypes.default.oneOf(['success', 'warning', 'danger', 'info']),
  size: _propTypes.default.oneOf(['small', 'medium', 'large'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(CircularProgress);

exports.default = _default;